import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Button, Input, ToastMessage } from '@cokitchen/cokitchen-components';
import AuthService from 'services/auth.service';
import { toast } from 'react-toastify';
import { ROUTE_KEYS } from 'utils/constants';
import { handleApiError } from 'utils/functions';

type CreateFormType = {
  password: string;
  confirm_password: string;
};
const CreateNewPassword = () => {
  const navigate = useNavigate();
  const { token } = useParams();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({} as CreateFormType);
  const [formError, setFormError] = useState<Partial<CreateFormType>>({});

  const formIsValid = (): boolean => {
    setFormError({});
    if (formData.password === formData.confirm_password) return true;
    if (formData.password === '') setFormError({ ...formError, password: 'Password is required' });
    if (formData.confirm_password === '')
      setFormError({ ...formError, confirm_password: 'Confirm Password is required' });

    if (formData.password !== formData.confirm_password) {
      setFormError(() => ({
        confirm_password: 'Passswords dont match',
        password: 'Passwords dont match'
      }));
    }
    return false;
  };

  const updateFormData = (key: string, value: string) => {
    setFormData((p) => ({ ...p, [key]: value }));
  };
  const handleConfirm = async () => {
    setLoading(true);
    if (!formIsValid()) return;
    const payload = {
      token: token,
      password: formData.password
    };
    try {
      const res = await AuthService.postAuthData('auth/reset', { ...payload });
      if (res) {
        toast(<ToastMessage type='success' message={'Password is reset'} />);
        localStorage.clear();
        navigate(`/${ROUTE_KEYS.AUTH}/${ROUTE_KEYS.LOGIN}?from=create-new-password`);
      }
    } catch (err) {
      handleApiError(err);
    } finally {
      setLoading(false);
    }
  };
  return (
    <div className='mx-auto max-w-[390px] '>
      <p className='text-[32px] font-semibold mb-4'>Create new password</p>
      <p className='text-[#6F7376] text-[16px] mb-12'>Ensure to create a new password</p>
      <div className='flex flex-col gap-7'>
        <Input
          design='bordered'
          placeholder='Password'
          label='Password'
          type='password'
          value={formData.password}
          error={formError.password}
          onChange={(e) => updateFormData('password', e.target.value)}
        />
        <Input
          design='bordered'
          placeholder='Confirm Password'
          label='Confirm Password'
          type='password'
          error={formError.confirm_password}
          value={formData.confirm_password}
          onChange={(e) => updateFormData('confirm_password', e.target.value)}
        />
        <Button
          small
          color='primary'
          className='mx-auto mt-9'
          variant='block'
          onClick={handleConfirm}
          loading={loading}
          disabled={!formData.confirm_password || !formData.password}>
          Continue
        </Button>
      </div>
    </div>
  );
};

export default CreateNewPassword;
